export const getTitleColor = (coffee: string): string => {
  switch (coffee) {
    case "Big Bad Daddy-O":
      return "text-green-600";
    case "Flip Your Whig!":
      return "text-red-500";
    case "Jamaican Betty Crazy":
      return "text-yellow-600";
    default:
      return "text-black";
  }
};
